module.exports = __webpack_public_path__ + "static/media/image_1.bd19c65a.png";